<div class="renaissance-style-scoped">
  <ng-container *ngIf="isEnabled; else disabledTemplate">
    <a *ngIf="context" class="deeplink" (click)="launchLink()" (keydown)="onKeydown($event)" tabindex="0" role="link">
      <img [src]="imageLink" alt="">
      <span>{{labelText}}</span>
      <span class="glyph glyph-externallink" tabindex="-1" role="img" aria-label="opens in a new tab"></span>
    </a>
  </ng-container>
  <ng-template #disabledTemplate>
    <a *ngIf="context" class="deeplink--disabled" tabindex="0" role="link" matTooltip="This link is only available to teachers" matTooltipPosition="below">
      <img [src]="imageLink" alt="">
      <span>{{labelText}}</span>
      <span class="glyph glyph-externallink" tabindex="-1" role="img"></span>
    </a>
  </ng-template>
</div>